import { graphQueryPromise } from './helpers';

export const getFeatureUserSettings = () => {
  const query = `{
    launchDarklySettings {
      key
      firstName
      lastName
      avatar
      email
      privateAttributeNames
      custom {
        customerId
        canImportJobs
        canPost1099
        isMarketplace
      }
    }
  }`;
  return graphQueryPromise(query);
};

export default getFeatureUserSettings;
